import type { HelpFile } from '../../types/help'
import { SchemaViolationsTestIds } from '../../../testids/SchemaViolationsTestIds'

export const schemaViolationsHelp: HelpFile = {
  docPage: '/docs/schema/violations',
  texts: {
    [SchemaViolationsTestIds.schemaViolationsList]:
      'Verstöße gegen Schema-Richtlinien — vom Substrat erkannte Drift. Jede Zeile verlinkt die betroffene Entität und nennt die ausgelöste Richtlinie.',
    [SchemaViolationsTestIds.colPolicy]: 'Die Schema-Richtlinie, deren Ausdruck für diese Zeile false ergab.',
    [SchemaViolationsTestIds.colDetectedAt]: 'Zeitpunkt der ersten Erkennung des Verstoßes.',
    [SchemaViolationsTestIds.colSeverity]: 'In der Richtlinie deklarierter Schweregrad — INFO, WARN, ERROR oder CRITICAL.',
    [SchemaViolationsTestIds.colStatus]: 'OPEN bis bestätigt; ACKED nach Bestätigung durch Admin; RESOLVED wenn die Drift behoben wurde.',
    [SchemaViolationsTestIds.colMessage]: 'Aus der Richtlinienvorlage gerenderte Meldung — bezeichnet die betroffene Entität meist mit Anzeigename.',
    [SchemaViolationsTestIds.colActions]: 'Aktionen pro Zeile — einzelnen Verstoß bestätigen.',
    [SchemaViolationsTestIds.colSelect]: 'Auswahl der Zeile für Sammelbestätigung umschalten.',
    [SchemaViolationsTestIds.checkboxToggleAll]: 'Auswahl aller sichtbaren Zeilen umschalten.',
    [SchemaViolationsTestIds.btnBulkAck]: 'Alle ausgewählten OPEN-Verstöße in einem Aufruf bestätigen.',
  },
}
